var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "100", height: "100", viewBox: "0 0 100 100", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M74.9972 35.9963V47.4748L39.7031 27.7318 49.9972 22.2222 74.9972 35.9963zM75 63.5439L65.1961 69.0535V64.003L25 41.9643V35.9955L34.8039 30.4858V35.9955L75 58.0342V63.5439zM25 64.0039V52.5254L59.8039 72.2684 50 77.7781 25 64.0039z", fill: "#203D4D", stroke: "#203D4D" })
  );
});